import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Navbar.css';

const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Services', to: '/services' },
  { label: 'Projects', to: '/projects' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // close menu on route change
  const handleNav = (to) => {
    setMenuOpen(false);
    navigate(to);
  };

  const handleWhatsApp = () => {
    setMenuOpen(false);
    window.open('https://wa.me/923036810903', '_blank', 'noopener,noreferrer');
  };

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="navbar-inner">
        <a className="navbar-logo" href="/" aria-label="Go to home page">
          <img className="navbar-logo-image" src="/images/logo.png" alt="Logo" />
        </a>

        {/* Desktop links */}
        <ul className="navbar-links">
          {navLinks.map(({ label, to }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                end={to === '/'}
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>

        <button className="btn-talk" onClick={handleWhatsApp}>
          Let's Talk
        </button>

        {/* Hamburger */}
        <button
          className={`hamburger${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
        {navLinks.map(({ label, to }) => (
          <button key={to} className="mobile-link" onClick={() => handleNav(to)}>
            {label}
          </button>
        ))}
        <button className="btn-talk mobile-talk" onClick={handleWhatsApp}>
          Let's Talk
        </button>
      </div>
    </nav>
  );
}
